export const SERVICE_CODE = 'PROJECTS' + '_SERVICE';
